// RFC 4180 CSV helpers for admin exports.

type CellValue = string | number | boolean | null | undefined;

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: CellValue): string {
  if (value === null || value === undefined) return "";
  const str = typeof value === "string" ? value : String(value);
  if (NEEDS_QUOTING.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function toCsv<T extends Record<string, CellValue>>(
  rows: T[],
  columns: ReadonlyArray<{ key: keyof T & string; label?: string }>,
): string {
  const header = columns.map((c) => escapeCell(c.label ?? c.key)).join(",");
  const lines = rows.map((row) =>
    columns.map((c) => escapeCell(row[c.key])).join(","),
  );
  // Prepend BOM so Excel auto-detects UTF-8 + use CRLF per RFC 4180.
  return "﻿" + [header, ...lines].join("\r\n");
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function csvFilename(section: string, from: string, to: string): string {
  return `carmen-${section}-${from}_${to}.csv`;
}
